module.exports = __webpack_public_path__ + "static/media/banner-home-6.794708b5.jpg";